import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isLoggedIn, authQlik } from 'action/auth'
import React, { useEffect } from 'react'
import Loader from 'view/component/loader'
import PropTypes from 'prop-types'
import LoggedOutRoutesPlcp from 'js/view-plcp/routes/logged-out-routes'
import LoggedInRoutesPLCP from 'js/view-plcp/routes/logged-in-routes'
import LoggedInRoutes from './logged-in-routes'
import LoggedOutRoutes from './logged-out-routes'

const Routes = ({ isAuthenticated, isLoggedIn, loginCheckComplete, authQlik }) => {
  useEffect(() => {
    if (!window.location.href.includes('mp')) {
      isLoggedIn()
    } else {
      isLoggedIn(true)
    }
  }, [])

  if (window.location.href.includes('plcp')) {
    if (window.location.href.includes('mp')) {
      return PLCPRoutes(true, true)
    }
    return PLCPRoutes(loginCheckComplete, isAuthenticated)
  } else {
    return datastoreRoutes(loginCheckComplete, isAuthenticated)
  }
}

const PLCPRoutes = (loginCheckComplete, isAuthenticated) => (
  loginCheckComplete && isAuthenticated
    ? <LoggedInRoutesPLCP />
    : loginCheckComplete
      ? <LoggedOutRoutesPlcp />
      : <Loader />)

const datastoreRoutes = (loginCheckComplete, isAuthenticated) => (
  loginCheckComplete && isAuthenticated
    ? <LoggedInRoutes />
    : loginCheckComplete
      ? <LoggedOutRoutes />
      : <Loader />)

Routes.propTypes = {
  isAuthenticated: PropTypes.bool,
  isLoggedIn: PropTypes.func,
  location: PropTypes.object,
  loginCheckComplete: PropTypes.bool
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loginCheckComplete: state.auth.loginCheckComplete
})

const mapDispatchToProps = (dispatch) => ({
  authQlik: bindActionCreators(authQlik, dispatch),
  isLoggedIn: bindActionCreators(isLoggedIn, dispatch)

})

export default connect(mapStateToProps, mapDispatchToProps)(Routes)
